import React from "react";
import Payment from "./content/payment";

const PaymentPage = () => {
	return <Payment />;
};

export default PaymentPage;
